import { render, staticRenderFns } from "./CenterCard.vue?vue&type=template&id=0281d1bd&scoped=true"
import script from "./CenterCard.vue?vue&type=script&lang=js"
export * from "./CenterCard.vue?vue&type=script&lang=js"
import style0 from "./CenterCard.vue?vue&type=style&index=0&id=0281d1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281d1bd",
  null
  
)

export default component.exports